import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSecurityPwa = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#9575CD' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeWidth={1.5}
      d='M17 19.16a1.24 1.24 0 0 1-1.238-1.238V16.07a1.239 1.239 0 0 1 2.476 0v1.852c0 .683-.555 1.238-1.238 1.238Z'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeWidth={1.5}
      d='M20.735 18.102A3.746 3.746 0 0 1 17 21.552c-2.07 0-3.75-1.68-3.75-3.75v-1.605c0-2.07 1.68-3.75 3.75-3.75a3.745 3.745 0 0 1 3.727 3.368'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M19.25 9.5h1.5c2.25 0 3.75 1.5 3.75 3.75v1.5M9.5 14.75v-1.5C9.5 11 11 9.5 13.25 9.5h1.5M19.25 24.5h1.5c2.25 0 3.75-1.5 3.75-3.75v-1.5M9.5 19.25v1.5c0 2.25 1.5 3.75 3.75 3.75h1.5'
    />
  </svg>
);
export default SvgSecurityPwa;
